import { Directive, Input, ElementRef, Inject } from '@angular/core';
@Directive({
  selector: '[focus]',
})
export class FocusDirective {
  @Input() focus: boolean = false;
  constructor(@Inject(ElementRef) private element: ElementRef) {}
  protected ngOnChanges() {
    if (this.focus == true) {
      this.element.nativeElement.focus();
    }
  }
}
